module.exports = __webpack_public_path__ + "img/ILR.295b5aae.png";